import React from 'react'
import PropTypes from 'prop-types'

import styles from './company-form-fields.css'
import TextInput from '@/modules/base/components/inputs/text-input/text-input'

const CompanyFormFields = (props) => {
  const { data = {}, errors, onTextInputChange } = props
  const { companyName, companyNameAffix } = data

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className='col-xs-6'>
          <TextInput
            required
            autoFocus
            dataQsId='companyFormFields-companyName'
            name='companyName'
            label='Firmenname*'
            value={companyName || name}
            errorMessage={errors['companyName']}
            onChange={onTextInputChange}
          />
        </div>
        <div className='col-xs-6'>
          <TextInput
            dataQsId='companyFormFields-companyNameAffix'
            name='companyNameAffix'
            label='Namenszusatz'
            value={companyNameAffix}
            onChange={onTextInputChange}
          />
        </div>
      </div>
    </div>
  )
}

CompanyFormFields.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  onTextInputChange: PropTypes.func,
}

export default CompanyFormFields
